/**
 * Design Check pages
 */

import React from 'react';
import './DesignCheck.css';

export { default as DesignCheckHome } from './DesignCheckHome';
export { default as AnalysisPage } from './AnalysisPage';
export { default as GuidePage } from './GuidePage';
export { default as ChatPage } from './ChatPage';
export { default as InviteLanding } from './InviteLanding';
export { default as InvitesPage } from './InvitesPage';
export { default as DesignCheckLayout } from './DesignCheckLayout';

/** Shown to clients after signing out (they have no portal to return to). */
export function DesignCheckGoodbye() {
  return (
    <div className="dc-shell">
      <div className="dc-center-page">
        <h1>You're signed out</h1>
        <p>
          Thanks for using Rapid Fusion Design Check. Your invite link will sign
          you straight back in while it's still active.
        </p>
      </div>
    </div>
  );
}
